import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import "./index.css";

class DeviceDropdown extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      userInput: "",
      dropdownLoading: true,
      selectedDevice: this.props.defaultValue ? this.props.defaultValue : undefined,
      selectedPrecincts: this.props.precinct ? this.props.precinct : [],
      selectedDisciplines: this.props.disciplines ? this.props.disciplines : []
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getAllDevices(this.state.userInput);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.precinct !== prevProps.precinct || this.props.discipline !== prevProps.discipline) {
      this.setState(
        {
          selectedPrecincts: this.props.precinct ? this.props.precinct : [],
          selectedDisciplines: this.props.discipline ? this.props.discipline : [],
          dropdownLoading: true
        },
        () => {
          this.getAllDevices(this.state.userInput);
        }
      );
    }

    if (this.props.reset !== prevProps.reset) {
      this.setState({
        selectedDevice: ""
      });
      this.props.change("");
    }
  }

  getAllDevices = input => {
    const url = "/api/v1/devices/";
    const { selectedPrecincts, selectedDisciplines } = this.state;
    const mount = this._isMounted;
    const params = {
      query: input ? input : "",
      precincts: selectedPrecincts,
      disciplines: selectedDisciplines
    };
    const errorMsg = "Unable to retrieve devices list.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      if (mount) {
        this.setState(() => {
          return { deviceList: json.results, dropdownLoading: false };
        });
        this.props.loading(false);
      }
    });
  };

  onInputChange = input => {
    this.setState({ dropdownLoading: true });
    this.getAllDevices(input);
  };

  handleChange = selectedOption => {
    this.setState({ selectedDevice: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption.map(c => c.id));
    }
  };

  render = () => {
    const { deviceList, selectedDevice, dropdownLoading } = this.state;

    if (!deviceList) {
      return null;
    }

    return (
      <div className="deviceDropdown">
        <FormGroup controlId="formDeviceDropdownSelect">
          <ControlLabel>Devices</ControlLabel>
          <Select
            name="device-dropdown-form-field-name"
            value={selectedDevice}
            isLoading={dropdownLoading}
            onInputChange={this.onInputChange}
            onChange={this.handleChange}
            valueKey="id"
            labelKey="name"
            multi={true}
            options={deviceList}
            placeholder="All devices"
          />
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(DeviceDropdown);



// WEBPACK FOOTER //
// ./src/_components/DeviceDropdown/index.js